import useSWR from "swr";
import useWishlist from "grandus-lib/hooks/useWishlist";
import { FrownOutlined, DeleteOutlined, LoadingOutlined } from "@ant-design/icons";

import { get, isEmpty } from "lodash";
import { Layout, Result, Button } from "antd";

import Listing from "components/product/listing/Listing";
import HeadLine from "components/header/HeadLine";
import {useTranslation} from "next-i18next";
import {fetchTranslations} from "utils/fetches";

const Wishlist = (props) => {
  const { wishlist, isLoading: isLoadingWishlist, itemRemove } = useWishlist();
  const { t } = useTranslation();
  
  const productsUrl = !isEmpty(get(wishlist, "productIds", []))
    ? `productIds=${get(wishlist, "productIds", []).join("&productIds=")}`
    : false;

  const { data: products, isLoading: isLoadingProducts, isValidating: isValidatingProducts } = useSWR(
    productsUrl
      ? `/api/lib/v1/products?${productsUrl}&fields=parameters,store,ean&perPage=${
          get(wishlist, "productIds", []).length
        }`
      : null,
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  const productsArray = get(products, "products", []);

  const isDataLoading = (isLoadingProducts || isValidatingProducts || isLoadingWishlist);

  if (isEmpty(wishlist?.productIds) && !isDataLoading) {
    return (
      <Layout className="container guttered">
        <Layout.Content>
          <Result
            icon={<FrownOutlined />}
            title={t("Zoznam obľúbených produktov")}
            subTitle={t("Zoznam obľúbených produktov je prázdny")}
          />
        </Layout.Content>
      </Layout>
    );
  }

  if (isDataLoading) {
    return (
      <Layout className="container guttered">
        <Layout.Content>
          <Result
            icon={<LoadingOutlined />}
            title={t("Zoznam obľúbených produktov")}
            subTitle={t("Načítavam…")}
          />
        </Layout.Content>
      </Layout>
    );
  }

  return (
    <Layout>
      <Layout.Content>
        <HeadLine style={`profile`}/>
        <div className="container">
          <Listing products={productsArray}  mapOptions={{"showDirections" : true, "showDownload" : true}}/>
        </div>
      </Layout.Content>
    </Layout>
  );
};

export default Wishlist;

export async function getServerSideProps({locale}) {
  return {
    props: {
      ...(await fetchTranslations(locale))
    }
  }
}